// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1nZ0s","empty":"ModalGraph_empty__RkFrl"};